import { getCountries, parsePhoneNumberFromString } from "libphonenumber-js";

const useValidatePhoneNumber = () => {
  const countries = getCountries();
  return (value: string) => {
    try {
      return countries.some((country) =>
        parsePhoneNumberFromString(value, country)?.isValid()
      );
    } catch (e) {
      return false;
    }
  };
};

export default useValidatePhoneNumber;
